import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";import { CircularProgress, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { RenderInputsRowByType } from '../../../../components/formGroupGenerator/RenderInputRowByType';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { CustomButton } from '../../../../components/customButton/CustomButton';

import { ADD_DOCUMENTO_CONTRATO } from '../../../../data/graphQL/mutations/Contratos/AddDocumentoContrato';
import { adaptTipoArchivoArray, GET_ALL_TIPO_ARCHIVO_DOCUMENTOS } from '../../../../data/graphQL/queries/Contratos/Documentacion/getTiposArchivo';
import toast from 'react-hot-toast';
import { obtenerDataImagen } from '../../../../actions/ImagenAction';
import { adaptDocumentoArray, GET_DOCUMENTOS_CONTRATO } from '../../../../data/graphQL/queries/Contratos/Documentacion/getDocumentosContrato';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { PopoverModal } from '../../../../components/popoverModal/PopoverModal';
import { adaptDocumentoById, GET_DOCUMENTO_CONTRATO_BY_ID } from '../../../../data/graphQL/queries/Contratos/Documentacion/getDocumentoContratoById';
import DocumentViewer from '../../../../components/DocumentViewer';
import { DELETE_DOCUMENTO_CONTRATO } from '../../../../data/graphQL/mutations/Contratos/DeleteDocumentoContrato';
import fileDownload from 'js-file-download';

const maxFileSize = 3;
const validExtensions = ['PNG', 'PDF', 'JPG'];

export const TabDocumentacion = ({
  contratoEditable,
  stepData,
  idEvaluacion,
  fullFormData,
  currentStep,
  refetchGestionPresupuestoRef,
  pageLoading,
  setPageLoading
}) => {

  const [idTipoArchivoSelected, setIdTipoArchivoSelected] = useState();
  const [tiposArchivo, setTiposArchivo] = useState([]);

  const [addDocumentoLoading, setAddDocumentoLoading] = useState(false);

  const [documentos, setDocumentos] = useState([]);

  const [fileToView, setFileToView] = useState();

  const handleView = async (row) => {
    const response = await getDocumentoById({
      variables: { idDocumento: row.idArchivo }
    });
    setFileToView(adaptDocumentoById(response?.data));
  };

  const handleDownload = async (row) => {
    const response = await getDocumentoById({
      variables: { idDocumento: row.idArchivo }
    });
    const doc = adaptDocumentoById(response?.data);

    const arr = new Uint8Array(doc.archivo);
    const documento = new Blob([arr], { type: doc.contentType });
    const fileName = doc.titulo + doc.extension;

    fileDownload(documento, fileName);


  };

  const handleDelete = async (row) => {
    try {
      const response = await deleteDocumento({ variables: { idDocumento: row.idArchivo } });
      await getDocumentos({ variables: { idEvaluacion }});
      if (response?.data?.deleteDocumentoContrato) {
        return toast.success('¡Documento eliminado con éxito!');
      }

      throw 'Se produjo un error al intentar agregar el documento';
    } catch (error) {
      toast.error(typeof error === 'string' ? error : 'Se produjo un error al intentar agregar el documento');
    }
  };

  const archivosColumns = generateColumnsDefaultConfiguration([
  {
    headerName: '',
    field: 'accion',
    flex: 0.03,
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return (
        <>
                        <PopoverModal closeOnClick>
                            <div className='popover-modal-content'>
                                <div aria-hidden='true' onClick={() => handleView(row)} className='item-option'>
                                    <VisibilityIcon className='edit-icon' />
                                    <span className='toggle-action'>Ver</span>
                                </div>
                                <div aria-hidden='true' onClick={() => handleDownload(row)} className='item-option'>
                                    <FileDownloadOutlinedIcon className='edit-icon' />
                                    <span className='toggle-action'>Descargar</span>
                                </div>
                                {/* No se puede editar la cotizacion en el contrato ni derivacion prescriptor (RP) en caso que se haya notificado al cordinador medico*/}
                                {!fullFormData.evaluacionAsistencial?.fechaNotifAsistencial && row?.idTipoArchivoDocumento === 36 && row?.idTipoArchivoDocumento !== 35 && contratoEditable && <div aria-hidden='true' onClick={() => handleDelete(row)} className='item-option'>
                                    <DeleteOutlinedIcon className='edit-icon' />
                                    <span className='toggle-action'>Eliminar</span>
                                </div>}
                            </div>
                        </PopoverModal>
                    </>);

    }
  },
  {
    headerName: '#',
    field: 'idArchivo',
    flex: 0.1
  },
  {
    headerName: 'Tipo de archivo',
    field: 'idTipoArchivoDocumento',
    flex: 0.23,
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return <>{tiposArchivo.find((x) => x.id === row.idTipoArchivoDocumento)?.displayName}</>;
    }
  },
  {
    headerName: 'Archivo',
    field: 'titulo',
    flex: 0.27

  },
  {
    headerName: 'Datos',
    field: 'datos',
    flex: 0.15
  },
  {
    headerName: 'Fecha de alta',
    field: 'fechaAlta',
    flex: 0.22
  }]
  );

  const { data: dataTipoArchivoDocumentos } = useQuery(GET_ALL_TIPO_ARCHIVO_DOCUMENTOS);

  useEffect(() => {
    if (!dataTipoArchivoDocumentos) return;
    setTiposArchivo(adaptTipoArchivoArray(dataTipoArchivoDocumentos));
  }, [dataTipoArchivoDocumentos]);

  useEffect(() => {
    async function fetchDocumentos() {
      if (!idEvaluacion) return;
      getDocumentos({variables: { idEvaluacion }});
    }

    fetchDocumentos();
  }, [
  idEvaluacion,
  fullFormData?.gestionPresupuestos?.presupuestoAutorizado,
  fullFormData?.gestionPresupuestos?.transferenciaParticulares,
  fullFormData?.datosPrincipales?.derivacionPrescriptor,
  currentStep]
  );

  const [getDocumentos, { data: documentosData, loading: getDocumentosLoading }] = useLazyQuery(GET_DOCUMENTOS_CONTRATO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!documentosData) return;
    setDocumentos(adaptDocumentoArray(documentosData));
  }, [documentosData]);

  const [getDocumentoById] = useLazyQuery(GET_DOCUMENTO_CONTRATO_BY_ID, {
    fetchPolicy: 'no-cache'
  });

  const [addDocumento] = useMutation(ADD_DOCUMENTO_CONTRATO);
  const [deleteDocumento] = useMutation(DELETE_DOCUMENTO_CONTRATO);

  const onClickAdjuntar = async ({ target: { files } }) => {
    try {
      setAddDocumentoLoading(true);
      const file = files[0];
      const { name, size } = file;
      const fileExtension = name.split('.').pop();
      const fileSizeToMB = (size / (1024 * 1024))?.toFixed(2);
      const fileNameIsValid = !new RegExp(/[&\#,+$~^%|\/":?<>{}]/g).test(name);

      if (fileSizeToMB > maxFileSize) {
        throw `Limite de tamaño alcanzado. (Max ${maxFileSize}MB)`;
      }
      if (!validExtensions?.includes(fileExtension?.toUpperCase())) {
        throw 'Extensión de archivo invalida.';
      }
      if (!fileNameIsValid) {
        throw 'Nombre del archivo no valido';
      }

      var image = await obtenerDataImagen(file);

      const updateFile = {
        contentType: image?.tipo,
        archivo: image?.data,
        extension: image?.extension,
        titulo: image?.nombre
      };

      const response = await addDocumento({
        variables: {
          idEvaluacion,
          documentoContratoState: idTipoArchivoSelected,
          documentoInput: updateFile
        }
      });
      if (response?.data?.addDocumentoContrato) {
        toast.success('¡Nuevo documento cargado!');
        refetchGestionPresupuestoRef.current?.();
        setIdTipoArchivoSelected();
        getDocumentos({variables: { idEvaluacion }});
      } else {
        throw 'Se produjo un error al intentar agregar el documento';
      }

    } catch (error) {
      toast.error(typeof error === 'string' ? error : 'Se produjo un error al intentar agregar el documento');
    } finally {
      setAddDocumentoLoading(false);
    }
  };

  const resetFileToView = () => setFileToView();

  if (pageLoading) {
    return (
      <div className='tab-loading-section-contrato'>
                <CircularProgress />
            </div>);

  }

  return <div>
        <Grid
      container
      columnSpacing={3}
      rowSpacing={3}
      columns={100}>
      
            {/* No se puede editar la cotizacion en el contrato (id 35)*/}
            <RenderInputsRowByType
        input={{
          displayName: 'Tipo de archivo',
          disabled: !contratoEditable,
          name: 'tipoArchivo',
          type: 'select',
          options: [...tiposArchivo.filter((x) => x.id !== 35)],
          col: 30
        }}
        value={idTipoArchivoSelected}
        handleChange={(name, value) => setIdTipoArchivoSelected(value)} />
      
            <Grid size={{ xs: 100, md: 15 }}>
                <CustomButton
          fullWidth
          variant='contained'
          component='label'
          disabled={!contratoEditable || !idTipoArchivoSelected}
          loading={addDocumentoLoading}
          onClick={() => {}}>
          
                    <input
            type='file'
            hidden
            onClick={(e) => e.target.value = ''}
            onChange={(e) => onClickAdjuntar(e)} />
          
                    Adjuntar
                </CustomButton>
            </Grid>
            <Grid container columnSpacing={3} rowSpacing={3} columns={100} size={{ xs: 100 }}>
                <Grid size={{ xs: 100 }}>
                    <h4>Tipos de archivos</h4>
                    <DataGridGenerico
            key={currentStep}
            columns={archivosColumns}
            maxWidth={archivosColumns.reduce((total, column) => total + (column.width || 0), 0)}
            rows={documentos}
            toolbar={false}
            loading={getDocumentosLoading}
            hideFooterPagination={true}
            autoHeight />
          
                </Grid>
            </Grid>
        </Grid>
        {!!fileToView && <DocumentViewer data={fileToView} setOpenDlg={resetFileToView} />}
    </div>;
};